import { useAppStore } from '../store/useAppStore';
import { Icon } from './Icon';
import { formatTon } from '../lib/format';

// Баннер крупного выигрыша — показывается всем при больших победах.
export function BigWinBanner() {
  const bigWin = useAppStore((s) => s.bigWin);
  return (
    <div className={`bigwin ${bigWin ? 'show' : ''}`}>
      {bigWin && (
        <>
          <span className="bigwin-icon">
            <Icon name="bolt" size={20} />
          </span>
          <div className="bigwin-text">
            <div className="bigwin-title">
              {bigWin.name} · крупный выигрыш
            </div>
            <div className="bigwin-amount">
              +{formatTon(bigWin.payout)} <span className="bigwin-mult">×{bigWin.multiplier.toFixed(2)}</span>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
